import { Assignment, BackHand, DisplaySettings, Info, Inventory, Photo, Science, Fireplace } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Context from "../../../../context/Context";
import Pendency from "../Pendency";
import language from '../../../../nls/language.json';
import { Button } from "@mui/base";
import './styles.css'

export default function ButtonsSectorPieces({ code, setIdScreen, handleTitle }) {
    const {
        setIdStep,
        getPartFlow,
        handleInfo,
        getBuffers,
        getMaterialForm,
        getSalesOrdersBI,
        setShowmodalIMG,
        setToolTipText,
        setShowModalFicha,
        selectedCountry,
        getSimilarParts,
        getFornosHitorico
    } = useContext(Context);
    const iconScaleSectorPieces = 1.2;

    useEffect(() => {
        handleFicha(92, code)
    }, [])

    const handleFicha = async (id, data) => {
        switch (id) {
            case 91:
                await getPartFlow(data);
                setIdStep(1);
                break;
            case 92:
                await handleInfo(data);
                setIdStep(2);
                break;
            case 93:
                await getBuffers(data);
                setIdStep(3);
                break;
            case 94:
                await getMaterialForm(data);
                setIdStep(4);
                break;
            case 95:
                await getSalesOrdersBI(data);
                setIdStep(5);
                break;
            case 96:
                setShowmodalIMG(data);
                break;
            case 97:
                setToolTipText((
                    <Pendency
                        data={data}
                        setIdScreenFicha={setIdScreen}
                    />
                ));
                setIdStep(7);
                setShowModalFicha(true)
                break;
            case 99:
                await getFornosHitorico(data);
                setIdStep(9);
                break;
        }
    }

    return (
        <Tabs
            defaultActiveKey={92}
            id="fill-tab-example"
            className="tab-ButtonsSectorPieces"
            onSelect={(e) => handleFicha(Number(e), code)}
        >
            <Tab
                eventKey={91}
                title={handleTitle(<DisplaySettings sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: 'white',
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.fluxo)}
            />
            <Tab
                eventKey={92}
                title={handleTitle(<Info sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: '#999999'
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.info)}
            />
            <Tab
                eventKey={93}
                title={handleTitle(<Inventory sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.racks)}
            />
            <Tab
                eventKey={94}
                title={handleTitle(<Science sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: '#31e658'
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.formula)}
            />
            <Tab
                eventKey={95}
                title={handleTitle(<Assignment sx={{
                    transform: `scale(${iconScaleSectorPieces})`,
                    color: "#744700"
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pedido)}
            />
            <Tab
                eventKey={96}
                title={handleTitle(<Photo color="secondary" sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.imagem)}
            />
            <Tab
                eventKey={97}
                title={handleTitle(<BackHand color="error" sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pendencia)}
            />

            {/* <Tab
                eventKey={98}
                title={handleTitle(<Science sx={{
                    transform: `scale(${iconScaleSectorPieces})`
                }} />, language[selectedCountry.name].Dashboard.pecasSetor.buttonsPecaSetor.pecasSemelhantes)}
            /> */}

            <Tab
            eventKey={99}
            title={handleTitle(<Fireplace sx={{transform: `scale(${iconScaleSectorPieces})` }}/>, "Forno" )}
            />
        </Tabs>
    )
}
